/**
 * string.js
 * provides additional string functions and polyfills
 */

// eslint-disable-next-line no-extend-native
String.prototype.trimLeft = function(charlist) {
  if (charlist === undefined) charlist = " ";

  return this.replace(new RegExp("^[" + charlist + "]+"), "");
};

// eslint-disable-next-line no-extend-native
String.prototype.trimRight = function(charlist) {
  if (charlist === undefined) charlist = " ";

  return this.replace(new RegExp("[" + charlist + "]+$"), "");
};

// eslint-disable-next-line no-extend-native
String.prototype.trim = function(charlist) {
  return this.trimLeft(charlist).trimRight(charlist);
};

// eslint-disable-next-line no-extend-native
String.prototype.truncate = function(length) {
  if (this.length > length) {
    let gapIndex = this.lastIndexOf(' ', length);
    return this.substring(0, gapIndex) + ' ...';
  }

  return this;
};

// eslint-disable-next-line no-extend-native
String.prototype.toTitleCase = function() {
  return this.replace(/(^|\s)\S/g, function(t) {
    return t.toUpperCase();
  });
};

// eslint-disable-next-line no-extend-native
String.prototype.toCamelCase = function() {
  return this.charAt(0).toLowerCase() + this.slice(1);
};

if (typeof String.prototype.replaceAll == "undefined") {  
  // eslint-disable-next-line no-extend-native
  String.prototype.replaceAll = function(match, replace) {  
    return this.replace(new RegExp(match, 'g'), () => replace);  
  };
}

// eslint-disable-next-line no-extend-native
String.prototype.startsWithVowel = function() {
  const vowels = ("aeiouAEIOU");
  return vowels.includes(this[0]);
};